import { Button, DialogActions, DialogContent, IconButton, Stack, Typography } from "@mui/material";
import { LassoSafeModalProps, LassoSafeType } from "./types";
import LassoModal from "../../components/LassoModal";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const LassoSafeModal = (props: LassoSafeModalProps) => {

    const handleClose = (_event: object, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason == "backdropClick") return;
        props.onClose();
    }


    const renderIcon: any = () => {
        if (!props.state.icon) return;
        return props.state.icon;
    }
    return (
        <LassoModal open={props.isOpen} onClose={handleClose} disableEscapeKeyDown>
            <Stack flexDirection="row" justifyContent="space-between" alignItems={"center"} sx={{ minWidth: "350px" }}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>Welcome to Lasso SAFE</Typography>
                <IconButton
                    data-testid="close-modal-button"
                    aria-label="close"
                    onClick={props.onClose}
                    sx={{
                        width: '24px',
                        height: '24px',
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </Stack>
            <DialogContent>
                <Stack
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={3}
                >
                    {renderIcon()}
                    <Typography>
                        {props.state.text}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {props.state?.button &&
                    <Button
                        variant={"primary"}
                        size={"large"}
                        onClick={props.state?.button?.action}
                    >
                        {props.state?.button?.text}
                    </Button>
                }
                {
                    props.state.type == LassoSafeType.DEFAULT &&
                    <Button
                        variant={"secondary"}
                        size={"small"}
                        onClick={props.onClose}
                    >
                        I need to finish my work
                    </Button>
                }
            </DialogActions>
        </LassoModal>
    )
}

export default LassoSafeModal;